import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgImportIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 10,
	viewBox: "0 0 12 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		className: "import-icon-st0",
		d: "M6 7.09091L8.18182 4.90909H6.54545V0H5.45455V4.90909H3.81818L6 7.09091ZM10.9091 0H7.63636V1.08545H10.9091V8.73818H1.09091V1.08545H4.36364V0H1.09091C0.490909 0 0 0.490909 0 1.09091V8.72727C0 9.32727 0.490909 9.81818 1.09091 9.81818H10.9091C11.5091 9.81818 12 9.32727 12 8.72727V1.09091C12 0.490909 11.5091 0 10.9091 0ZM6 7.09091L8.18182 4.90909H6.54545V0H5.45455V4.90909H3.81818L6 7.09091ZM10.9091 0H7.63636V1.08545H10.9091V8.73818H1.09091V1.08545H4.36364V0H1.09091C0.490909 0 0 0.490909 0 1.09091V8.72727C0 9.32727 0.490909 9.81818 1.09091 9.81818H10.9091C11.5091 9.81818 12 9.32727 12 8.72727V1.09091C12 0.490909 11.5091 0 10.9091 0Z",
		fill: "currentColor"
	})
});
export default SvgImportIcon;
